import 'lightgallery/dist/js/lightgallery';
import 'lightgallery/modules/lg-fullscreen';
import 'lightgallery/modules/lg-hash';
import 'lightgallery/modules/lg-thumbnail';
import 'lightgallery/modules/lg-video';
export default {
  init() {
      console.log('cargamos single-recinto');
    let lg = $('#lightgallery');
    lg.lightGallery({
      mode: 'lg-fade',
      cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)',
      thumbnail:true,
      animateThumb: true,
      showThumbByDefault: true,
      Width: 100,
      Height: 100,
    });


    let lgSala = $('#lightgallerySala');
    lgSala.lightGallery({
      mode: 'lg-fade',
      cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)',
      thumbnail:true,
      animateThumb: true,
      showThumbByDefault: true,
      Width: 100,
      Height: 100,
    });

    $('.capaEspectaculo').on('mouseover', function(e){
      e.stopPropagation();
      $(this).find('.capaBotonComprar').css('display','flex');
    });

    $('.capaEspectaculo').on('mouseout', function(e){
      e.stopPropagation();
      $(this).find('.capaBotonComprar').css('display','none');
    })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-recinto.js